export default {
	status: {
		All: "Všetky",
		Pending: "Čaká sa na",
		Frozen: "Zmrazené",
		Completed: "Dokončené",
		Undone: "Nedokončené"
	},
	TotalAmount: "Celková suma",
	Profit: "Zisk",
	Expire: "Vypršať"
};
